'use client';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { DataLayerWhere } from '@/modules/cart/services/data-layer-events/add-to-cart';

import { SamplesFilterBarActions } from './SamplesFilterBar';

export function SamplesFilterBarActionsPortal({
  mountId,
  where,
}: {
  mountId: string;
  where?: DataLayerWhere;
}) {
  const [mountEl, setMountEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setMountEl(document.getElementById(mountId));
  }, [mountId]);

  if (!mountEl) {
    return null;
  }

  return createPortal(<SamplesFilterBarActions where={where} />, mountEl);
}
